module.exports = __webpack_public_path__ + "img/lock.7c4925e2.png";